import React from 'react'
import EntitySummary from './EntitySummary'
import { Link, useNavigate } from 'react-router-dom'
import { Button, Card } from 'react-bootstrap'
import { styles } from '../layout/styles'
import { grey } from '../../config/Colors';

const EntityList = (params) => {
    const navigate = useNavigate();
    const entities = params.entities;
    const wellness = params.wellness

    if (!entities) {
        return (
            <div>Loading entities...</div>
        )
    } else {
        return (
            <div>
                <div className='entity-list section'>
                    <Card style={{ alignContent:'center', alignItem:'center', justifyContent: "center"}}>
                        <Card.Body>
                            <Card.Title> 
                            <div style={{display:'flex', flexDirection:"row"}}>
                                <div style={{flex:'1', margin:'10px', minWidth:'30%'}}><h3 style={styles.SubHeader}>My Kids</h3></div>
                                <div style={{flex:'2', margin:'10px', minWidth:'30%'}}></div>
                                <div style={{flex:'3', margin:'10px', minWidth:'30%', textAlign:'right', verticalAlign:'center'}}>
                                    <Link style={styles.SubLink} to={'/createentity'}>
                                        <span class="material-symbols-outlined" style={{fontSize:'32px'}}>person_add</span>
                                    </Link>
                                    {/* <Button style={styles.CDButton} onClick={() => navigate("/createentity")}>Add</Button> */}
                                </div>
                            </div>                                                                
                            </Card.Title>
                            <Card.Text>
                                {entities && entities.map(entity => {
                                return  (
                                    // <Link to={'/entitydetails/' + entity.id}>
                                        <EntitySummary entity={entity} wellness={wellness} key={entity.id}/>
                                    // </Link>
                                )
                            })
                            }
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </div>
            </div>
        )    
    }
}

export default EntityList